import { gateway } from "../../../gateway";

export const sendInvitation = async ({ token, email, companyName, targetName }) => {
    try {
        const response = await gateway.post(
            `/mobile/send-download`,
            { email, companyName, targetName },
            { headers: { Authorization: `${token}` } }
        );

        return response.data?.data || response.data;
    } catch (error) {
        console.error("Error sending invitation", error);
        throw error;
    }
};
